import { differenceInMonths, format as formatDate, isFuture, isPast } from 'date-fns';
import { tt } from '#i18n/index.ts';
import { type RibbonSeasonDetailsData } from '../types.ts';

export const deriveSeasonRibbonMessage = ({ airDate, episodes }: RibbonSeasonDetailsData['season']) => {
  const lastEpisode = episodes?.length ? episodes.at(-1) : undefined;
  let message: string | undefined;

  switch (true) {
    case airDate && isFuture(new Date(airDate)): {
      {
        const airDateObj = new Date(airDate);

        const dateStr =
          differenceInMonths(airDateObj, new Date()) < 2
            ? formatDate(airDateObj, 'MMM d')
            : `${formatDate(airDateObj, 'MMM')} '${formatDate(airDateObj, 'yy')}`;

        message = `${tt('ribbons.season.airs')} ${dateStr}`;
      }

      break;
    }

    case airDate && isPast(new Date(airDate)) && lastEpisode?.airDate && isFuture(new Date(lastEpisode.airDate)): {
      message = tt('ribbons.season.airingNow');

      break;
    }

    default:
    // no default
  }

  return message;
};
